/**
 * Copyright (c) S2 Partnership Ltd. 2022
 *
 * A service that implements Encryption for the App
 *
 * @summary Implements Encryption
 * @author S2
 *
 * Created at     : 17-06-2021
 */

import { Injectable } from '@angular/core';
import hmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import AES from 'crypto-js/aes';
import { constants } from './../../../../constants';
import { environment } from './../../../../environments/environment';

@Injectable()
export class EncryptionService {

  /**
   * Standard Angular Constructor.
   *
   * @ignore
   */
  constructor() {
    // Empty constructor.
  }

  /**
   * Decrypts value.
   *
   * @arg {string} value The value to decrypt.
   * @return {string} Decrypted value.
   */
  decrypt(value: string): string {
    return AES.decrypt(value, environment.encryptionKey).toString(Utf8);
  }

  /**
   * Encrypts value.
   *
   * @arg {string} value String the value to encrypt.
   * @return {string} Encrypted value.
   */
  encrypt(value: string): string {
    return AES.encrypt(value, environment.encryptionKey).toString();
  }

  /**
   * Hashes message.
   *
   * @arg {string} message String the value to hash.
   * @return {string} Hashed message.
   */
  hash(message: string): string {
    return Base64.stringify(hmacSHA512(message, constants.hmacKey));
  }
}
